import { TNullable } from '@/types';
import { TInstitutionWhiteLabelServerCamel } from '@/types/institutions';

/**
 * Returns the subdomain an institution should be accessed on based on its whitelabel settings.
 * Whitelabel-enabled institutions use their configured subdomain;
 * all others fall back to the default app subdomain.
 * @param whitelabel - The whitelabel settings to resolve.
 * @returns Lowercase subdomain string.
 */
export const getInstitutionWhitelabelSubdomain = (
  whitelabel: TNullable<Partial<TInstitutionWhiteLabelServerCamel>>,
): string => {
  return whitelabel?.enabled && whitelabel?.subdomain
    ? whitelabel.subdomain.toLowerCase()
    : import.meta.env.VITE_DEFAULT_SUBDOMAIN;
};
